<template>
  <div class="text-editor" v-on:click="preventClick">
    <div class="mt-3">
      <b-input-group prepend="TEXT">
        <b-form-input
          placeholder="Enter text here..."
          :value="text"
          v-on:input="onChangeText"
          rows="2"
          class="text-element"
        />
      </b-input-group>
    </div>

    <div>
      <div role="group" class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text">SIZE</div>

          <div class="font-size-slider">
            <vue-slider
              ref="sizeSlider"
              v-model="tempSizeValue"
              :min="0.3"
              :max="1.5"
              :interval="0.1"
              tooltip-placement="right"
              tooltip="always"
              @change="onChangeFontSize"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="mb-3">
      <div role="group" class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text">COLOR</div>
        </div>

        <div
          class="form-control text-color-element"
          id="text-color-popover"
          :style="{ backgroundColor: textColor.hex }"
        />

        <b-popover
          target="text-color-popover"
          triggers="click blur"
          placement="right"
          ref="textColorPopover"
        >
          <ColorPicker
            v-on-clickaway="close"
            :colors="colorsCategories.textColors"
            @onSelectColor="onChangeTextColor"
          />
        </b-popover>
      </div>
    </div>

    <div>
      <b-button v-on:click="onAddText()" variant="success">ADD TEXT</b-button>
    </div>
  </div>
</template>

<script>
import ColorPicker from '@/components/common/ColorPicker.vue';
import 'vue-slider-component/theme/default.css';
import VueSlider from 'vue-slider-component';
import { mixin as clickaway } from 'vue-clickaway';

export default {
  name: 'TextEditor',
  mixins: [clickaway],
  components: {
    ColorPicker,
    VueSlider
  },

  props: {
    text: String,
    textSize: Number,
    textColor: Object
  },

  data () {
    return {
      tempSizeValue: 1
    };
  },

  watch: {
    textSize (newTextSize) {
      this.$refs.sizeSlider.setValue(newTextSize);
    }
  },

  computed: {
    colorsCategories () {
      return this.$store.getters['elements/getColorsCategories'];
    },
  },

  mounted () {
    this.$refs.sizeSlider.setValue(this.textSize);
  },

  methods: {
    close () {
      this.$refs.textColorPopover.$emit('close');
    },

    preventClick (event) {
      event.stopPropagation();
    },

    onChangeText (text) {
      this.$emit('onChangeText', text.toUpperCase());
    },

    onChangeTextColor (color) {
      this.$emit('onChangeTextColor', color);
      this.$refs.textColorPopover.$emit('close');
    },

    onAddText () {
      if (this.text) {
        this.$emit('onAddText', this.text, this.textColor, this.$refs.sizeSlider.getValue());
      }
    },

    onChangeFontSize (value) {
      this.$emit('onChangeFontSize', value);
    }
  }
};
</script>

<style scoped>
.text-editor {
  align-items: center;
  flex-direction: column;
  display: flex;
  justify-content: center;

  .input-group-prepend {
    .input-group-text {
      background: #1c539c;
      color: #ffffff;
      font-weight: bold;
      justify-content: center;
      width: 80px;
    }
  }

  .text-color-element {
    cursor: pointer;
    width: 200px;
  }

  .text-element {
    width: 200px;
  }

  .font-size-slider {
    align-self: center;
    width: 199px;
  }
}
</style>
